module.exports = __webpack_public_path__ + "static/media/expand-content-dark.129493f5.svg";